import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

export default function TooltipBox(props) {
   return (
      <>
         <OverlayTrigger
            placement='right'
            delay={{ show: 250, hide: 400 }}
            overlay={
               <Tooltip id='button-tooltip' {...props}>
                  {props.text}
               </Tooltip>
            }
         >
            {props.component}
         </OverlayTrigger>
      </>
   );
}

TooltipBox.propTypes = {
   text: PropTypes.string,
   component: PropTypes.element,
};
